module.exports = __webpack_public_path__ + "static/media/rouletteStart_4.8fa0f668.mp3";